import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: string | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(err: Error): State {
    return { error: err.message };
  }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    console.error('[Tank Battle]', err, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 16, color: '#ff8a80', fontFamily: 'system-ui' }}>
          <h2>Tank Battle — ошибка</h2>
          <p>{this.state.error}</p>
          <p style={{ opacity: 0.7, fontSize: 14 }}>
            Попробуйте закрыть и открыть Mini App снова.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
